import _slicedToArray from "/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.string.trim.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Alert from '@/components/shared/Alert';
import Panel from '@/components/shared/Panel';
import LocationAdministrationForm from '@/components/location-administration/LocationAdministrationForm';
import LocationGroupAdderModal from '@/components/location-administration/LocationGroupAdderModal';
import { LocationAdministration, Location } from '@/services/ResourceService';
import ScrollAnimatorService from '@/services/ScrollAnimatorService';
import { Bus as VuedalsBus } from 'vuedals';
import _ from 'lodash';
export default {
  name: 'LocationAdministrationEditor',
  components: {
    Alert: Alert,
    Panel: Panel,
    LocationAdministrationForm: LocationAdministrationForm
  },
  props: {
    isCreation: {
      type: Boolean,
      required: true
    },
    locationId: {
      type: Number,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {
      isLoading: true,
      isSubmitting: false,
      isReloadingForeignKeyValues: false,
      successfullySaved: false,
      validationErrorOccurred: false,
      serverErrorOccurred: false,
      rawLocationData: null,
      editedLocationData: null,
      foreignKeyValues: null,
      validationErrors: null
    };
  },
  created: function created() {
    if (this.isCreation) {
      this.initializeNewLocationData();
    } else {
      this.loadLocationData();
    }
  },
  methods: {
    loadLocationData: function loadLocationData() {
      var _this = this;
      this.isLoading = true;
      Promise.all([LocationAdministration.getLocation(this.$store.state.general.companyId, this.locationId), LocationAdministration.getForeignKeyValues(this.$store.state.general.companyId)]).then(function (response) {
        _this.rawLocationData = response[0].data;
        _this.foreignKeyValues = response[1].data;
        _this.editedLocationData = _.cloneDeep(_this.rawLocationData);
        _this.setValidSurveyStateAfterLoadingData();
        _this.isLoading = false;
      }, function () {
        _this.serverErrorOccurred = true;
        _this.isLoading = false;
      });
    },
    updateForeignKeyValues: function updateForeignKeyValues() {
      var _this2 = this;
      this.isReloadingForeignKeyValues = true;
      this.serverErrorOccurred = false;
      LocationAdministration.getForeignKeyValues(this.$store.state.general.companyId).then(function (response) {
        _this2.foreignKeyValues = response.data;
        _this2.isReloadingForeignKeyValues = false;
      }).catch(function () {
        _this2.serverErrorOccurred = true;
        _this2.isReloadingForeignKeyValues = false;
      });
    },
    initializeNewLocationData: function initializeNewLocationData() {
      var _this3 = this;
      this.isLoading = true;
      this.editedLocationData = {
        id: null,
        name: null,
        address: null,
        region: 'NORDWESTSCHWEIZ',
        locationGroupId: null,
        defaultLanguage: 'DE',
        surveyId: null,
        customLogoBright: null,
        customLogoDark: null
      };
      LocationAdministration.getForeignKeyValues(this.$store.state.general.companyId).then(function (response) {
        _this3.foreignKeyValues = response.data;
        if (_this3.foreignKeyValues.locationGroups.length > 0) {
          _this3.editedLocationData.locationGroupId = _this3.foreignKeyValues.locationGroups[0].id;
        }
        _this3.isLoading = false;
      }).catch(function () {
        _this3.serverErrorOccurred = true;
        _this3.isLoading = false;
      });
    },
    openLocationGroupModal: function openLocationGroupModal() {
      var _this4 = this;
      VuedalsBus.$emit('new', {
        title: this.$t('locationGroupModalTitle'),
        name: 'location-group-adder',
        component: LocationGroupAdderModal,
        onClose: function onClose(options) {
          if (options.locationGroupId !== null) {
            _this4.updateForeignKeyValues();
            _this4.editedLocationData.locationGroupId = options.locationGroupId;
          }
        }
      });
    },
    submitForm: function submitForm() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this5.isSubmitting = true;
              _this5.validationErrorOccurred = false;
              _this5.serverErrorOccurred = false;
              _this5.successfullySaved = false;
              _this5.validationErrors = null;
              _this5.replaceEmptyStringsWithNull();
              _context.prev = 6;
              if (!_this5.isCreation) {
                _context.next = 12;
                break;
              }
              _context.next = 10;
              return _this5.createLocation();
            case 10:
              _context.next = 14;
              break;
            case 12:
              _context.next = 14;
              return _this5.updateLocation();
            case 14:
              _context.next = 16;
              return _this5.updateLocationsInStore();
            case 16:
              _this5.onSubmissionSuccess();
              _context.next = 22;
              break;
            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](6);
              _this5.onSubmissionError(_context.t0);
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[6, 19]]);
      }))();
    },
    createLocation: function createLocation() {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return LocationAdministration.createLocation(_this6.$store.state.general.companyId, _this6.editedLocationData);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    updateLocation: function updateLocation() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return LocationAdministration.updateLocation(_this7.$store.state.general.companyId, _this7.locationId, _this7.editedLocationData);
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    updateLocationsInStore: function updateLocationsInStore() {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _yield$Location$getAl, locations;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return Location.getAllowedLocations(_this8.$store.state.general.companyId);
            case 2:
              _yield$Location$getAl = _context4.sent;
              locations = _yield$Location$getAl.data;
              _this8.$store.commit('general/setAllLocations', locations);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    onSubmissionSuccess: function onSubmissionSuccess() {
      var _this9 = this;
      if (this.isCreation) {
        setTimeout(function () {
          _this9.$router.push({
            name: 'location-administration'
          });
        }, 1000);
      }
      this.isSubmitting = false;
      this.successfullySaved = true;
      ScrollAnimatorService.scrollToTopOfElement(this.$el);
    },
    onSubmissionError: function onSubmissionError(error) {
      var data = error.response.data;
      var errorCode = data.status.code;
      var payload = data.payload;
      if (errorCode === 400 && payload !== null && payload.length > 0) {
        this.validationErrorOccurred = true;
        this.validationErrors = payload;
      } else {
        this.serverErrorOccurred = true;
      }
      this.isSubmitting = false;
      ScrollAnimatorService.scrollToTopOfElement(this.$el);
    },
    setValidSurveyStateAfterLoadingData: function setValidSurveyStateAfterLoadingData() {
      var _this10 = this;
      var surveys = this.foreignKeyValues.surveys;
      if (surveys.length === 0 || !surveys.find(function (survey) {
        return survey.id === _this10.editedLocationData.surveyId;
      })) {
        this.editedLocationData.surveyId = null;
      }
    },
    replaceEmptyStringsWithNull: function replaceEmptyStringsWithNull() {
      for (var _i = 0, _Object$entries = Object.entries(this.editedLocationData); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          propertyKey = _Object$entries$_i[0],
          propertyValue = _Object$entries$_i[1];
        if (typeof propertyValue === 'string' && propertyValue.trim() === '') {
          this.editedLocationData[propertyKey] = null;
        }
      }
    }
  }
};